import {api} from './requestGraphql'

const getCustomAssets = async (pagination, sorting, filters) => {

    let preparedFilters = ''

    for (const filter in filters) {
        preparedFilters += (!!filters[filter]) ?
            `${filter}: "${filters[filter]}"` : ''
    }

    try {
        const res = await api.post(
            '', {
                query: `
                {
                    getCustomAssets(
                        pagination: { page: ${pagination.page}, limit: ${pagination.limit} }, 
                        sorting: { orderBy: "${sorting.orderBy}", orderDirectionAsc: ${sorting.orderDirectionAsc} }
                        filters: { ${preparedFilters} }
                    ) {
                        count
                        data {
                            id
                            name
                            param
                            type
                            value
                            affiliateId
                            dateUpdated
                            access
                            user
                            preSignedUrl
                            tags {
                                id
                                name
                            }
                        }
                    }
                }
                `,
            }
        );

        let response = res.data.data.getCustomAssets;
        console.log(`response ${JSON.stringify(response)}`);
        return response;
    } catch (e) {
        console.log(e);
    }
};

const getCustomAssetsFilterData = async (fields) => {
    try {
        const res = await api.post('', {
            query: `
                {
                  getCustomAssetsFilterData {
                    filters {
                      id {
                        key
                        value
                      }
                      type {
                        key
                        value
                      }
                      name {
                        key
                        value
                      }
                      value {
                        key
                        value
                      }
                      access {
                        key
                        value
                      }
                      tags {
                        key
                        value
                      }                      
                    }
                  }
                }
      `,
        });

        let response = res.data.data.getCustomAssetsFilterData;
        console.log(`getCustomAssetsFilterData response : `, response);
        return response;
    } catch (e) {
        console.error(e);
    }

}
const getCustomAssetsTags = async () => {
    try {
        const res = await api.post('', {
            query: `
                {
                    getCustomAssetsTags {
                        id
                        name
                    }
                }
      `,
        });

        let response = res.data.data.getCustomAssetsTags;
        console.log(`getCustomAssetsTags response : `, response);
        return response;
    } catch (e) {
        console.error(e);
    }

}


const createOrUpdateCustomAssets = async (data) => {
  let { id, name, type, value, affiliateId, isEdit, imageFileName, keywordField, selectedTagsObj } = data;

  let param;
  switch (type) {
    case "background":
      param = "bg";
      value = imageFileName;
      break;
    case "product_image":
      param = "pi";
      value = imageFileName;
      break;
    case "keyword":
      param = "kw";
      value = keywordField;
      break;
    case "product_name":
      param = "pn";
      value = keywordField;
      break;
    default:
      throw new Error(`Unsupported asset type: ${type}`);
  }

  const tagsString = selectedTagsObj
    .map(tag => `{ id: ${tag.id || null}, name: "${tag.name}" }`)
    .join(", ");

  try {
    const res = await api.post('', {
      query: `
                mutation {
                  createOrUpdateCustomAssets(
                    data: {
                      id: ${id || null}
                      isEdit: ${isEdit || false}
                      name: "${name}"
                      param: "${param}"
                      type: ${type.toUpperCase().replace(' ', '_')}
                      value: "${value || ''}"
                      affiliateId: ${affiliateId || null}
                      tags: [${tagsString}]
                    }
                  ) {
                    id
                    isSuccess
                  }
                }
            `,
    });

    let response = res.data.data.createOrUpdateCustomAssets;
    console.log(`createOrUpdateCustomAssets mutation response: `, response);
    return response;
  } catch (e) {
    console.error(`Error in createOrUpdateCustomAssets: `, e);
    throw e; // Re-throw the error for upstream handling if needed
  }
};

const deleteCustomAssets = async (id) => {
    try {
        const res = await api.post('', {
            query: `
                mutation {
                  deleteCustomAssets(id: ${id})
                }
      `,
        });

        let response = res.data.data.deleteCustomAssets;
        console.log(`deleteCustomAssets mutation response : `, response);
        return response;
    } catch (e) {
        console.error(e);
    }

}
const sendFileToS3 = async ({id, text, filename, type, extension}) => {
    try {
        const res = await api.post('', {
            query: `
                mutation {
                  sendFileToS3(
                    id: ${id}
                    text: "${text}"
                    filename: "${filename}"
                    type: ${type.toUpperCase()}
                    extension: "${extension}"
                  ){
                    path
                    isSuccess
                  }
                }
      `,
        });

        let response = res.data.data.sendFileToS3;
        console.log(`sendFileToS3:`, response);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const customAssetsImageUploadUrl = async (filename, type, extension, method) => {
    try {
        const res = await api.post('', {
            query: `
        mutation {
          customAssetsImageUploadUrl(
            filename: "${filename}"
            type: ${type}
            extension: "${extension}"
            method: ${method}
          )
        }
      `,
        });

        let response = res.data.data.customAssetsImageUploadUrl;
        console.log(`Image Upload URL: ${response}`);
        return response;
    } catch (e) {
        console.error(e);
    }
};

const getAvailableId = async () => {
    try {
        const res = await api.post('', {
            query: `
                {
                  getAvailableId
                }
      `,
        });

        let response = res.data.data.getAvailableId;
        return response;
    } catch (e) {
        console.error(e);
    }

}

const getCustomAssetsHistoryById = async (id) => {
    try {
        const res = await api.post('', {
            query: `
                {
                  getCustomAssetsHistoryById(id:${id}){
                    entity
                    user
                    action
                    dateAdded
                    logs
                  }
                }
            `,
        });

        return res.data.data.getCustomAssetsHistoryById;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export default {
    getCustomAssets,
    getCustomAssetsTags,
    getCustomAssetsFilterData,
    deleteCustomAssets,
    customAssetsImageUploadUrl,
    createOrUpdateCustomAssets,
    getAvailableId,
    sendFileToS3,
    getCustomAssetsHistoryById

}